import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _sharedLayout, _styled, _titleLine, _appInfo, _objectSpread3, _styled2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled, alpha } from '@mui/system';
import { PROMETHEAN_NEUTRAL_WHITE, PROMETHEAN_NEUTRAL_MID_GREY, PROMETHEAN_TEXT, PROMETHEAN_DARK_PURPLE, PROMETHEAN_TEXT_HEADER } from '../../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_H3 } from '../../styles/typography/typography';
import { EmbersGrid } from '../../grid/grid';
import { PROMETHEAN_BREAKPOINT_XL, PROMETHEAN_BREAKPOINT_XXL, PROMETHEAN_BREAKPOINT_SM, PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT } from '../../styles/breakpoints/breakpoints';
export var COLUMN_BREAKPOINT = 1281;
var sharedLayout = (_sharedLayout = {
  width: 1536
}, _defineProperty(_sharedLayout, "@media screen and (min-width: ".concat(PROMETHEAN_BREAKPOINT_XXL, "px)"), {
  width: 1536
}), _defineProperty(_sharedLayout, "@media screen and (max-width: ".concat(1536 + 128, "px)"), {
  width: '100%',
  maxWidth: "".concat(1536 + 128, "px"),
  padding: '0 64px'
}), _defineProperty(_sharedLayout, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_XL, "px) and (min-width: ").concat(COLUMN_BREAKPOINT + 128, "px)"), {
  width: 1280,
  padding: 0
}), _defineProperty(_sharedLayout, "@media screen and (max-width: ".concat(COLUMN_BREAKPOINT + 128, "px)"), {
  width: '100%',
  maxWidth: "".concat(1280 + 128, "px"),
  padding: '0 64px'
}), _defineProperty(_sharedLayout, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px)"), {
  width: '100%',
  padding: '0 24px'
}), _sharedLayout);
export var StyledColumnSectionGroup = styled('div')(function (_ref) {
  var _objectSpread2;
  var count = _ref.count;
  return _objectSpread(_objectSpread({}, sharedLayout), {}, (_objectSpread2 = {
    margin: '64px auto'
  }, _defineProperty(_objectSpread2, "@media screen and (min-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT, "px)"), {
    '.MuiGrid-item': {
      flexBasis: "".concat(100 / count, "%"),
      maxWidth: "".concat(100 / count, "%")
    }
  }), _defineProperty(_objectSpread2, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
    margin: '32px 0'
  }), _objectSpread2));
});
export var StyledColumnSection = styled(EmbersGrid)((_styled = {}, _defineProperty(_styled, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
  display: 'flex',
  flexDirection: 'column',
  padding: 0
}), _defineProperty(_styled, '.EmbersTemplate-marketingColumns', {
  '&-circle': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    width: 72,
    height: 72,
    i: {
      fontSize: '52px',
      '&:before': {
        color: PROMETHEAN_NEUTRAL_WHITE
      }
    }
  },
  '&-title': {
    color: PROMETHEAN_TEXT_HEADER
  }
}), _styled));
export var StyledMarketingBanner = styled('div')({
  width: '100%',
  background: PROMETHEAN_DARK_PURPLE,
  '&.EmbersTemplate-marketingBanner': {
    '&-expandedBy-picture': {
      '.EmbersTemplate-marketingBanner-content-root': {
        padding: 0,
        display: 'flex',
        alignItems: 'center'
      }
    }
  }
});
export var StyledMarketingBannerContent = styled('div')(_objectSpread(_objectSpread({
  display: 'flex',
  justifyContent: 'space-between'
}, sharedLayout), {}, (_objectSpread3 = {
  margin: '56px auto',
  '.EmbersTemplate': {
    '&-marketingBanner-content': {
      '&-root': {
        '.MuiTypography-root': {
          color: PROMETHEAN_NEUTRAL_WHITE
        }
      },
      '&-appInfo': (_appInfo = {
        width: 614
      }, _defineProperty(_appInfo, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_XL + 1, "px)"), {
        width: 512
      }), _defineProperty(_appInfo, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
        width: '100%'
      }), _defineProperty(_appInfo, '&-titleLine', (_titleLine = {
        display: 'flex'
      }, _defineProperty(_titleLine, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
        justifyContent: 'center',
        alignItems: 'center'
      }), _defineProperty(_titleLine, '&-logo', _defineProperty({
        width: 72,
        height: 72,
        marginRight: 24
      }, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px)"), {
        marginRight: 0
      })), _defineProperty(_titleLine, '&-description', {
        marginTop: 8
      }), _titleLine)), _defineProperty(_appInfo, '&-other', _defineProperty({
        marginLeft: 96
      }, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
        marginLeft: 0
      })), _appInfo),
      '&-divider': {
        margin: '32px 0',
        borderColor: alpha(PROMETHEAN_NEUTRAL_WHITE, 0.3)
      }
    },
    '&-marketingBanner-picture': {
      '&-area': _defineProperty({
        position: 'relative'
      }, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
        '&> *': {
          display: 'block',
          maxWidth: '100%'
        }
      }),
      '&-box': {
        position: 'absolute',
        right: 0,
        top: 0
      }
    },
    '&-marketingBanner-signIn': {
      '.MuiTypography-root': {
        color: PROMETHEAN_NEUTRAL_WHITE
      },
      '&-createAccount': _defineProperty({
        marginTop: 40
      }, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
        marginTop: 0
      })
    },
    '&-marketingBanner-extend-area': {
      '.MuiTypography-root': {
        color: PROMETHEAN_NEUTRAL_WHITE
      }
    }
  }
}, _defineProperty(_objectSpread3, "@media screen and (min-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT, "px)"), {
  '.EmbersTemplate-marketingBanner-picture': {
    '&-area': {
      maxWidth: 'calc(100% - 512px)',
      '& > *': {
        maxWidth: '100%'
      }
    }
  }
}), _defineProperty(_objectSpread3, "@media screen and (min-width: ".concat(PROMETHEAN_BREAKPOINT_XL, "px)"), {
  '.EmbersTemplate-marketingBanner-picture': {
    '&-area': {
      maxWidth: 'calc(100% - 612px)'
    }
  }
}), _defineProperty(_objectSpread3, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_MARKETING_WRAP_BREAKPOINT - 1, "px)"), {
  justifyContent: 'center',
  textAlign: 'center',
  flexDirection: 'column',
  '.EmbersTemplate': {
    '&-marketingBanner-content': {
      '&-appInfo': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '&-other': {
          marginTop: 40,
          marginLeft: 0
        }
      },
      '&-downloadArea': {
        button: {
          margin: '0 auto 32px'
        }
      }
    },
    '&-marketingBanner-picture': {
      '&-area': {
        position: 'static!important',
        margin: '40px auto'
      },
      '&-box': {
        position: 'static!important',
        width: '100%'
      }
    },
    '&-marketingBanner-signIn-area': {
      '.MarketingBanner-signIn': {
        '&-createAccount': {
          marginTop: 0
        }
      }
    },
    '&-marketingBanner-extend-area > *': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }
}), _defineProperty(_objectSpread3, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px)"), {
  padding: '0 24px',
  '.EmbersTemplate': {
    '&-marketingBanner-content': {
      '&-appInfo': {
        '&-titleLine': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          '&-logo': {
            marginRight: 0,
            marginBottom: 24
          },
          '&-text': {
            h2: _objectSpread({}, PROMETHEAN_TYPOGRAPHY_H3)
          }
        },
        '&-other': {
          marginTop: '24px !important'
        }
      }
    }
  }
}), _objectSpread3)));

// Circle
export var StyledCicleArea = styled('div')((_styled2 = {
  width: 480,
  '@media screen and (max-width: 544px)': {
    width: 'calc(100vw - 128px)'
  }
}, _defineProperty(_styled2, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px)"), {
  width: '100%'
}), _defineProperty(_styled2, '.EmbersTemplate-marketingCircle', {
  '&-product': {
    width: '100%',
    borderRadius: '50%',
    '>*': {
      width: '100%',
      height: '100%'
    },
    '&-description': {
      fontFamily: 'Noto Sans',
      fontStyle: 'italic',
      fontWeight: 400,
      fontSize: 14,
      lineHeight: '21px',
      textAlign: 'center',
      color: PROMETHEAN_TEXT,
      marginTop: 24
    }
  }
}), _styled2));
export var StyledRowLayout = styled('div')(_objectSpread(_objectSpread({}, sharedLayout), {}, _defineProperty({
  paddingBottom: '70px!important',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  '.EmbersTemplate-marketingGroup-item': {},
  '@media screen and (max-width: 1562px)': {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
}, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px)"), {
  width: '100%',
  padding: '0 24px 50px 24px'
})));
export var StyleMarketingBottom = styled('div')(_defineProperty({
  background: PROMETHEAN_NEUTRAL_MID_GREY,
  width: '100%',
  padding: '0 64px',
  textAlign: 'center'
}, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px)"), {
  padding: '0 24px'
}));
export var StyleGuestBottom = styled('div')(_defineProperty({
  background: PROMETHEAN_NEUTRAL_MID_GREY,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '32px 64px',
  textAlign: 'center',
  button: {
    width: 'fit-content'
  }
}, "@media screen and (max-width: ".concat(PROMETHEAN_BREAKPOINT_SM - 1, "px)"), {
  padding: '32px 24px'
}));